import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowUpRight } from "lucide-react";
import { WhatsAppIcon, WA_LINK } from "@/components/marketing/WhatsAppIcon";

const QUICK = [
  { label: "About", href: "#about" },
  { label: "Named Patient", href: "#named-patient" },
  { label: "LATAM · MENA · Africa", href: "#latam" },
  { label: "Services", href: "#services" },
  { label: "Why Heliopolis", href: "#why-us" },
  { label: "Global Network", href: "#network" },
  { label: "Contact", href: "#contact" },
];

export default function SiteFooter() {
  return (
    <footer className="relative bg-[#0D1B2A] text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <img src="/heliopolis-logo-dark.png" alt="Heliopolis Pharmaceuticals" className="h-12 w-auto" onError={(e) => { e.currentTarget.src = "/heliopolis-logo.png"; e.currentTarget.className = "h-12 w-auto bg-white rounded-lg p-1.5"; }} />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              Licensed B2B pharmaceutical supply and temperature-controlled logistics, connecting global
              manufacturers with healthcare systems from the Dubai DMCC Free Zone.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["GDP Compliant", "Cold-Chain Certified", "DMCC Licensed"].map((b) => (
                <span key={b} className="rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs font-medium text-white/70">{b}</span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-[#F5C64D]">Explore</h4>
            <ul className="mt-5 space-y-3">
              {QUICK.map((q) => (
                <li key={q.label}>
                  <a href={q.href} className="group inline-flex items-center gap-1 text-sm text-white/70 hover:text-white transition-colors" data-testid={`footer-link-${q.label.toLowerCase().replace(/\s/g, "-")}`}>
                    {q.label}
                    <ArrowUpRight size={13} className="opacity-0 -translate-x-1 transition-all group-hover:opacity-100 group-hover:translate-x-0" />
                  </a>
                </li>
              ))}
              <li>
                <Link to="/login" className="inline-flex items-center gap-1 text-sm font-semibold text-white hover:text-[#F5C64D]" data-testid="footer-portal-link">Enter ERP Portal</Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-[#F5C64D]">Get in touch</h4>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              <li className="flex gap-3"><MapPin size={18} className="mt-0.5 shrink-0 text-[#377DD3]" /><span>DMCC Free Zone, Jumeirah Lakes Towers, Dubai, United Arab Emirates</span></li>
              <li className="flex gap-3"><Mail size={18} className="shrink-0 text-[#377DD3]" /><a href="mailto:customercare@heliopolispharmaceuticals.com" className="break-all hover:text-white">customercare@heliopolispharmaceuticals.com</a></li>
              <li className="flex gap-3"><Phone size={18} className="shrink-0 text-[#377DD3]" /><a href="tel:+971547741436" className="hover:text-white">+971 54 774 1436</a></li>
              <li className="flex gap-3"><WhatsAppIcon size={18} className="shrink-0 text-[#25D366]" /><a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid="footer-whatsapp-link">WhatsApp: +971 54 774 1436</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/50 sm:flex-row">
          <p>© {new Date().getFullYear()} Heliopolis Pharmaceuticals. All rights reserved.</p>
          <p>B2B Pharmaceutical Supply • Named Patient Supply • DMCC Free Zone</p>
        </div>
      </div>
    </footer>
  );
}
